import { Action } from '@ngrx/store';
import { PlantsRequest } from '@cemex-core/cmx-api/models/order-management/plants-request';
import { PlantsResponse } from '@cemex-core/cmx-api/models/order-management/plants-response';
import { Plant, PlantPatchRequest } from '@cemex-core/cmx-api';
export const RESET = '[Product Plants] Reset';

export const LOAD_PRODUCT_PLANTS = '[Product Plants] Load Product Plants';
export const LOAD_OWNFREIGHT_PLANTS = '[OwnFreight Plants] Load OwnFreight Plants';
export const LOAD_PRODUCT_PLANTS_COMPLETE = '[Product Plants] Load Product Plants Complete';
export const LOAD_OWNFREIGHT_PLANTS_COMPLETE = '[Ownfreight Plants] Load Product Plants Complete';

export const ADD_PRODUCT_PLANT = '[Product Plants] Load Product Plant';

export class LoadProductPlantsAction implements Action {
  readonly type = LOAD_PRODUCT_PLANTS;

  constructor(public payload: PlantsRequest) {}
}

export class LoadOwnFreightPlants implements Action {
  readonly type = LOAD_OWNFREIGHT_PLANTS;

  constructor(public payload: PlantPatchRequest) {}
}

export class LoadProductPlantsCompleteAction implements Action {
  readonly type = LOAD_PRODUCT_PLANTS_COMPLETE;

  constructor(public payload: PlantsResponse) {}
}

export class LoadOwnFreightPlantsCompleteAction implements Action {
  readonly type = LOAD_OWNFREIGHT_PLANTS_COMPLETE;

  constructor(
    public payload: {
      productId: number;
      plants: Plant[];
    },
  ) {}
}

export class AddProductPlantAction implements Action {
  readonly type = ADD_PRODUCT_PLANT;

  constructor(public payload: Plant) {}
}

export class ProductPlantsResetAction implements Action {
  readonly type = RESET;

  constructor() {}
}

export type ProductPlantsActions =
  | LoadProductPlantsAction
  | LoadProductPlantsCompleteAction
  | ProductPlantsResetAction
  | AddProductPlantAction
  | LoadOwnFreightPlants
  | LoadOwnFreightPlantsCompleteAction;
